import React from 'react';
import ReactDOM from 'react-dom';
import { useNavigate, useParams } from 'react-router-dom';
import { finishExam, leaveExam } from '../../assets/api/userActions';

import { ReactComponent as Cancel } from '../../assets/icons/cancel.svg';

import classes from '../../styles/components/modals/uploadModal.module.scss';

const BackDrop = (props) => {
    return <div className={`${classes.modalBackDrop} ${classes.modalBackDropShadow}`} onClick={props.onClose}></div>;
};

const OverlayConfirmExitModal = (props) => {

    const navigate = useNavigate();
    const params = useParams();

    const handleConfirm = async () => {
        if (props.leave) {
            const res = await leaveExam(props.attemptID);
            if (res.status === "success-leave") {
                navigate("/quiz/join/" + params.quiz);
            }
        } else {
            const res = await finishExam(props.attemptID);
            if (res.status === "success-finish") {
                navigate("/quiz/finish");
            }
        }
    };

    const handleConfirmClick = () => {
        if (typeof props.onConfirm === "function") {
            void props.onConfirm();
            return;
        }
        void handleConfirm();
    };

    return (
        <div className={classes.imageModal}>
            <div className={classes.imageModal__container}>
                <div className={classes.imageModal__cancel_btn} onClick={props.onClose} >
                    <Cancel width="32px" height="32px" />
                </div>
                <div className={classes.confirmModal}>
                    {
                        props.leave ?
                            <p className={classes.confirmModal__title}>{`آیا میخواهید آزمون را ترک کنید ؟`}</p> :
                            <p className={classes.confirmModal__title}>{`آیا میخواهید آزمون را تمام کنید ؟`}</p>
                    }
                    <div className={classes.confirmModal__btn_container}>
                        <div className={classes.confirmModal__cancel_btn} onClick={props.onClose} >انصراف</div>
                        <div className={classes.confirmModal__confirm_btn} onClick={handleConfirmClick}>تایید</div>
                    </div>
                </div>
            </div>
        </div>
    )
}

const ExitModal = (props) => {
    return (
        <React.Fragment>
            {ReactDOM.createPortal(<BackDrop onClose={props.onClose} />, document.getElementById("backdrop-root"))}
            {ReactDOM.createPortal(
                <OverlayConfirmExitModal
                    onClose={props.onClose}
                    leave={props.leave}
                    attemptID={props.attemptID}
                    onConfirm={props.onConfirm}
                />,
                document.getElementById("overlayConfirmExitModal-root"),
            )}
        </React.Fragment>
    )
}

export default ExitModal;